import { colors } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

export const CalenderFilterEnum = {
  All: 0,
  This_Week: 1,
  Last_Week: 2,
  This_Month: 3,
  Last_Month: 4,
  This_Quarter: 5,
  Last_Quarter: 6,
  This_6_Months: 7,
  Last_6_Months: 8,
  This_Year: 9,
  Last_Year: 10,
  Custom_Date_Range: 11,
  Todays: 12, // <-- Add this new value
};
// utils/reactSelectStyles.js
export const globalSelectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  menu: (base) => ({
    ...base,
    zIndex: 99999,
    maxHeight: "250px", // Set max height for the dropdown
    overflowY: "auto", // Enable scrolling if needed
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "200px", // Adjust list height
    overflowY: "auto",
    zIndex: 99999999,
  }),
  control: (base) => ({
    ...base,
    fontSize: "12px",
    minHeight: "38px",
  }),
  option: (base, state) => ({
    ...base,
    // height: "30px",
    fontSize: "12px",
    padding: "6px 10px",
    backgroundColor: state.isSelected ? "#E86B1B" : "white",
    color: state.isSelected ? "white" : "black",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#F4AD80",
      color: "black",
    },
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    color: "black",
  }),
};

export const JobEnum = {
  JobInformation: 1,
  TaskSheet: 2,
  JobTimeline: 3,
  MissingLog: 4,
  Queries: 5,
  Draft: 6,
  Documents: 7,
  Reviewer: 8,
};

export const JobListEnum = {
  All: null,
  Completed: 1,
  PredefinedJob: 2,
  Assign: 3,
};
export const JobTaskListEnum = {
  All: null,
  Do: 1,
  Delegate: 2,
  Demand: 3,
  LatterOn: 4,
};
export const SettingEnum = {
  UsersRole: 1,
  Designation: 2,
  Services: 3,
  ClientIndustry: 4,
  Statuses: 5,
  Checklist: 6,
  ClientGrouping: 7,
  LeaveType: 8,
  KRA: 9,
  ProjectStage: 10,
  TimeSlotMaster: 11,
};
export const UserEnum = {
  ManageUser: 1,
  DeactivateUser: 2,
};
export const FrequencyEnum = {
  Monthly: 1,
  Yearly: 2,
  Onetime: 3,
  Custom: 4,
};

export const CampaignEnum = {
  UpcomingCampaigns: 1,
  CompletedCampaigns: 2,
};

export const ReportEnum = {
  PaymentSummaryReport: 1,
  JobReport: 2,
  TaskReport: 3,
  ProjectReport: 4,
  AttendanceReport: 5,
  ProfitabilityReport: 6,
  TeamPerformanceReport: 7,
  KRAReport: 8,
  ServiceReport: 9
};